import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { FaTimes } from "react-icons/fa";

export default function CompanyFormsTableColumnSettingsModal({
  open,
  onClose,
  columns,
  visibility,
  onToggle,
  onReset,
}) {
  useEffect(() => {
    if (!open) return undefined;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [open]);

  if (!open) return null;

  return createPortal(
    <div className="tailwind-container">
      <div
        className="fixed inset-0"
        style={{ zIndex: 10040, backgroundColor: "rgba(0, 0, 0, 0.55)" }}
        onMouseDown={onClose}
        aria-hidden="true"
      />
      <div
        className="fixed inset-0 flex items-center justify-center p-4 sm:p-6"
        style={{ zIndex: 10050 }}
      >
        <div
          role="dialog"
          aria-modal="true"
          aria-labelledby="cf-table-columns-title"
          className="pointer-events-auto w-[min(calc(100vw-1.5rem),32rem)] overflow-hidden rounded-xl border border-slate-200/90 bg-slate-50 shadow-[0_20px_40px_-12px_rgba(15,23,42,0.16)]"
          onMouseDown={(e) => e.stopPropagation()}
        >
          <header className="flex w-full items-center justify-between gap-2 border-b border-slate-200/70 bg-white px-4 py-3">
            <div className="min-w-0 flex-1 text-left">
              <h2
                id="cf-table-columns-title"
                className="m-0 text-[13px] font-semibold leading-tight text-slate-900"
              >
                Table columns
              </h2>
              <p className="mb-0 mt-0.5 text-[11px] leading-snug text-slate-500">
                Choose which columns appear in this table.
              </p>
            </div>
            <button
              type="button"
              onClick={onClose}
              aria-label="Close"
              className="inline-flex h-7 w-7 shrink-0 items-center justify-center rounded-md border-0 bg-slate-100 text-slate-500 outline-none transition hover:bg-slate-200/80 hover:text-slate-700 focus:outline-none focus:ring-2 focus:ring-slate-200"
            >
              <FaTimes size={11} aria-hidden="true" />
            </button>
          </header>

          <div className="bg-slate-50 px-4 py-3.5">
            <div className="grid grid-cols-2 gap-2.5">
              {columns.map((column) => {
                const checked = visibility[column.key] !== false;
                return (
                  <label
                    key={column.key}
                    htmlFor={`cf-col-${column.key}`}
                    className={`flex cursor-pointer items-center gap-2.5 rounded-lg border px-3 py-2.5 text-[13px] font-medium leading-tight transition ${
                      checked
                        ? "border-blue-200 bg-blue-50/80 text-blue-900"
                        : "border-slate-200/80 bg-white text-slate-700 hover:border-slate-300"
                    }`}
                  >
                    <input
                      id={`cf-col-${column.key}`}
                      type="checkbox"
                      className="m-0 h-3.5 w-3.5 shrink-0 cursor-pointer rounded border-slate-300 accent-[#007BFF]"
                      checked={checked}
                      onChange={() => onToggle(column.key)}
                    />
                    <span className="min-w-0 truncate">{column.title}</span>
                  </label>
                );
              })}
            </div>
          </div>

          <footer className="flex w-full items-center justify-between gap-2 border-t border-slate-200/70 bg-white px-4 py-3">
            <button
              type="button"
              onClick={onReset}
              className="inline-flex min-h-[2rem] shrink-0 items-center justify-center rounded-md border-0 bg-slate-50 px-3 py-1.5 text-xs font-medium text-slate-600 outline-none ring-1 ring-slate-200/80 transition hover:bg-slate-100 focus:outline-none focus:ring-2 focus:ring-slate-200"
            >
              Reset defaults
            </button>
            <button
              type="button"
              onClick={onClose}
              className="inline-flex min-h-[2rem] shrink-0 items-center justify-center rounded-md border-0 bg-[#007BFF] px-3.5 py-1.5 text-xs font-semibold text-white shadow-sm outline-none transition hover:bg-[#0069d9] focus:outline-none focus:ring-2 focus:ring-[#007BFF]/30"
            >
              Done
            </button>
          </footer>
        </div>
      </div>
    </div>,
    document.body,
  );
}
